import { z } from "zod";

export const SYSTEM_ROLES = {
  ADMIN: "admin",
  USER: "user",
} as const;

/** Type-safe array of role values for iterations */
export const SYSTEM_ROLE_VALUES = ["admin", "user"] as const;

/** Zod schema for runtime validation */
export const systemUserRoleSchema = z.enum(SYSTEM_ROLE_VALUES);

/** TypeScript type: "admin" | "user" */
export type SystemUserRole = z.infer<typeof systemUserRoleSchema>;

/** Helper to check if a string is a valid system role */
export const isValidSystemRole = (role: unknown): role is SystemUserRole => {
  return systemUserRoleSchema.safeParse(role).success;
};

/** Map from uppercase (Supabase) to lowercase (our system) */
export const SYSTEM_ROLE_MAP: Record<string, SystemUserRole> = {
  ADMIN: SYSTEM_ROLES.ADMIN,
  USER: SYSTEM_ROLES.USER,
};